import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractSubObjectCreateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimCreateWorkOrderChangeSubObjectGql } from '../bimWorkOrderChangeStructureQueries';

const requestId = 'bimCreateWorkOrderChangeSubObject';

export const useBimCreateWorkOrderChangeSubObject = (
    workOrderChangeId?: number,
    onSuccess?: (newSubObjectId?: number) => void,
) => {
    const dispatch = useDispatch();

    const [bimCreateWorkOrderSubObjectReset] = useResetStoreData({ requestId });

    const [
        bimCreateWorkOrderChangeSubObjectData,
        bimCreateWorkOrderChangeSubObjectStatus,
        bimCreateWorkOrderChangeSubObjectError,
        bimCreateWorkOrderChangeSubObjectRequest,
    ] = useRequest({
        requestId,
        query: bimCreateWorkOrderChangeSubObjectGql,
        withEffect: false,
    });

    const bimCreateWorkOrderChangeSubObjectChangeMakeRequest = useCallback(
        (input: BimContractSubObjectCreateInput) => {
            dispatch(bimCreateWorkOrderChangeSubObjectRequest({ workOrderChangeId, input }));
        },
        [bimCreateWorkOrderChangeSubObjectRequest, dispatch, workOrderChangeId],
    );

    useEffect(() => {
        bimCreateWorkOrderSubObjectReset(undefined);
    }, [bimCreateWorkOrderSubObjectReset]);

    useEffect(() => {
        if (
            bimCreateWorkOrderChangeSubObjectStatus === RequestStatus.SUCCESS &&
            bimCreateWorkOrderChangeSubObjectData?.bimCreateWorkOrderChangeSubObject?.data?.id
        ) {
            bimCreateWorkOrderSubObjectReset(undefined);
            onSuccess?.(bimCreateWorkOrderChangeSubObjectData?.bimCreateWorkOrderChangeSubObject?.data?.id);
        }
    }, [
        bimCreateWorkOrderChangeSubObjectData?.bimCreateWorkOrderChangeSubObject?.data?.id,
        bimCreateWorkOrderSubObjectReset,
        bimCreateWorkOrderChangeSubObjectStatus,
        onSuccess,
    ]);

    return {
        bimCreateWorkOrderChangeSubObjectData,
        bimCreateWorkOrderChangeSubObjectStatus,
        bimCreateWorkOrderChangeSubObjectError,
        bimCreateWorkOrderChangeSubObjectChangeMakeRequest,
    };
};
